<div class="modal-header blue">
  <div class="d-flex align-items-center">
    <h4 class="modal-title mr-3">
      <ng-container *ngIf="!isClaimsEdit">
        {{
          isEditMode ? 'Edit Eligibility Routing' : 'Add Eligibility Routing'
        }}
      </ng-container>

      <ng-container *ngIf="isClaimsEdit">
        {{
          isEditMode ? 'Edit Claim Status Routing' : 'Add Claim Status Routing'
        }}
      </ng-container>
    </h4>
  </div>

  <a href="javascript:void(0)" class="modal-close-btn" (click)="close()"></a>
</div>

<form [formGroup]="claimStatusRoutingForm" class="modal-body payer-modal">
  <div class="form-row md mb-3">
    <div class="col">
      <div class="input-label">payer name</div>

      <ng-select
        [items]="payers"
        placeholder="Enter Receiver id"
        bindLabel="name"
        bindValue="name"
        appendTo="body"
        formControlName="payerName"
        [loading]="isPayerLoading"
        (scrollToEnd)="onScrollToEnd()"
        [searchFn]="customSearchFn"
        (search)="onSearch($event)"
        [class.is-invalid]="
          claimStatusRoutingForm.get('payerName')?.touched &&
          claimStatusRoutingForm.get('payerName')?.invalid
        "
      >
        <ng-template ng-label-tmp let-item="item">
          <div [title]="item.name">
            {{ item.id + ' - ' + item.name }}
          </div>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-search="searchTerm"
          let-index="index"
        >
          <span>{{ item.id + ' - ' + item.name }}</span>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="form-row md mb-3">
    <div class="col-6">
      <div class="input-label">SC ID</div>
      <input
        type="text"
        maxlength="80"
        formControlName="scId"
        placeholder="Enter SC ID"
        class="input"
      />
    </div>
    <div class="col-6">
      <div class="input-label">group ID</div>
      <input
        type="text"
        maxlength="6"
        formControlName="groupId"
        placeholder="Enter Group ID"
        class="input"
      />
    </div>
  </div>

  <div class="form-row md mb-3">
    <div class="col-6">
      <div class="input-label">Processor ID</div>
      <input
        type="text"
        maxlength="15"
        formControlName="processorId"
        placeholder="Enter Processor ID"
        class="input"
      />
    </div>
    <div class="col-6">
      <div class="input-label">edi ID</div>
      <input
        type="text"
        maxlength="25"
        formControlName="ediId"
        placeholder="Enter Edi ID"
        class="input"
      />
    </div>
  </div>

  <div class="form-row md">
    <div class="col">
      <checkbox
        formControlName="recordStatus"
        checkedValue="A"
        uncheckedValue="I"
      >
        Active
      </checkbox>
    </div>
  </div>
</form>

<div class="modal-footer">
  <button class="button w-100px ml-auto" (click)="save()">
    {{ isEditMode ? 'Save' : 'Add' }}
  </button>
</div>
